<script lang="ts">
import {defineComponent} from 'vue'
import MediaGalleryListActions from "@src/Resources/epim/Templates/MediaGallery/components/MediaGalleryListActions.vue";
import {mapGetters} from "vuex";

export default defineComponent({
    name: "MediaGalleryActionBar",
    components: {MediaGalleryListActions},
    computed: {
        selectedCount() {
            return this.$store.getters.getSelectedAssetIds.length
        }
    },
})
</script>

<template>
    <div class="container action-bar">
        <div class="row">
            <div class="col-12 action-bar__actions">
                <slot name="actions"/>
            </div>
            <div class="col-12 action-bar__separator">
                <hr/>
            </div>
            <div class="col-12 action-bar__secondary-actions">
                <slot name="secondary-actions">
                    <span>
                        {{ selectedCount }} {{ $t('mediaGallery.actions.selected') }}
                    </span>
                    <media-gallery-list-actions/>
                </slot>
            </div>
        </div>
    </div>
</template>
